<template>
  <Layout>
    <template #content>
      <div class="mainContent">
        <pageHead device="desktop" page="live" :title="Title" :description="$t('store.live_description')"/>
        <div class="game-wrap pclive">
          <h1 class="title"><span class="bg">{{ Title }}</span><q class="dn fg">{{ Title }}</q></h1>
          <div class="game-list one-piece accordion-gallery live">
            <template v-for="(item, index) in Product(ProductId)">
              <gameMod
                v-model="item.Id"
                :productId="ProductId"
                :className="`game-group product_${item.Id} ${item.Maintain}`"
                :data-text="$t('store.uphold_ing')"
              />
            </template>
          </div>
        </div>
      </div>
    </template> 
  </Layout>
</template>
<script>
  const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
  import pageHead from "~/components/common/pageHead.vue";
  import gameMod from "~/components/desktop/gameMod.vue";
  export default {
    components: {
      Layout,
      pageHead,
      gameMod,
    },
    data() {
      return {
        ProductId: 2,
      };
    },
    computed: {
      HasX() {
        return Object.keys(this.$route.query).indexOf('x') >= 0;
      },
      Title() {
        if (this.HasX)
          return '線上百家樂' + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
        else
          return this.$t("store.game_live") + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
      },
      ...mapGetters(["Product", "WebSeoName", "ShowPageWebSeoName"])
    },
  };
</script>

<style scoped></style>
